import {SummaryRecord} from './summary-record.model';
import {Record} from './record.model';
import {DealPayrollBreakdown, PayrollCalculationMethod} from './deal-payroll.model';
import {PayrollMonthlyRate} from './payroll-currency.model';

export interface ReportProgress {
  percent: number;
  stage: string;
  completed: boolean;
  failed: boolean;
}

export class Report {
  public monthlyRate?: PayrollMonthlyRate;
  public userID?: string;
  public firstName: string;
  public lastName: string;
  public records: Record[];
  public summaryRecord: SummaryRecord;
  public howSalaryCalculated?: string[];
  public payrollMethod?: boolean;
  public payrollCalculationMethod?: PayrollCalculationMethod;
  public dealPayrollBreakdown?: DealPayrollBreakdown;

  constructor(firstName: string, lastName: string, records: Record[], summaryRecord: SummaryRecord) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.records = records;
    this.summaryRecord = summaryRecord;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/report.model.ts